const YuthAndSportsdata = [
    {
        id : "1",
        schemeName: "Cash Awards To Medal In International Sports Events And Their Coaches",
        discription:"The Scheme of Cash Awards to Medal Winners in International Sports Events and Their Coaches was introduced in the year 1986 by the Department of Sports, Ministry of Youth Affairs & Sports.",
        launchDate: "Year 1986",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Pandit Deendayal Upadhyay National Welfare Fund For Sportspersons.",
    discription:"The scheme promotes the welfare of the sportspersons generally in order to alleviate distress among them and their dependents. The scheme can be administered for active sportspersons individually or collectively as a group.",
    launchDate: "March 1982",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Tenzing Norgay National Adventure Award.",
    discription:"The Ministry of Youth Affairs and Sports, Government of India confers the National Adventure Award called “Tenzing Norgay National Adventure Award” (TNNAA) in order to recognize the achievements of persons associated in the field of adventure and to encourage young people to develop the spirit of endurance, risk-taking, cooperative teamwork and quick, ready and effective reflexes in challenging situations. ",
    launchDate: "write",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Scheme for Arjuna for Outstanding Performance in Sports.",
        discription:"The honor is named after Prince Arjuna , the protagonist of the Indian epic Mahabharata”. The Sportspersons are honored each year (one award is allotted in each discipline) with a bronze statue of Arjuna, a scroll, and a cash prize..",
        launchDate: "13 November",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Scheme of Sports Fund For Pension to Meritorious Sportpersons",
    discription:"A pension scheme by the Ministry of Youth Affairs & Sports to provide additional financial security to sportspersons post-retirement from active sports career in the form of a lifetime pension, payable on attaining the age of 30 years (or date of retirement from active sports whichever is later).",
    launchDate: "Year 1994", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "Major Dhyan Chand Khel Ratna Award Scheme ",
    discription:"Named after the hockey wizard Major Dhyan Chand (1905–79), an Indian legendary field hockey player, Major Dhyan Chand Khel Ratna Award (erstwhile Rajiv Gandhi Khel Ratan Award) is the highest sporting honour of India. Instituted in 1991–1992, the award is conferred annually by the Ministry of Youth Affairs and Sports, Government of India.",
    launchDate: "write",
    AnualFund: "12345"
},
{   id : "7",
schemeName: "Maulana Abul Kalam Azad Trophy .",
discription:"The Maulana Abul Kalam Azad (MAKA) Trophy instituted in year 1956-57 is a rolling trophy awarded by the Ministry of Sports to the overall top performing University in sports of the preceding year for promoting competitive sports in the university sector with a view to arouse keen interest among students and motivate teams to take up competitive sports..",
launchDate: "write",
AnualFund: "12345"},


{   id : "8",
schemeName: "Rashtriya Khel Protsahan Puruskar .",
discription:"The Scheme Rashtriya Khel Protsahan Puruskar was instituted in the year 2009 by the Department of Sports. There are four categories of awards under the Scheme:(a) Identification and nurturing of budding/young talent (b) Encouragement to sports through Corporate Social Responsibility (c) Employment of sports persons and sports welfare measures (d) Sports for Development",
launchDate: "Year 2009",
AnualFund: "12345"},


{   id : "9",
schemeName: "Dhyan Chand Award for life-time Achievement Sports and Games.",
discription:"Named after the hockey wizard Major Dhyan Chand (1905–79), an Indian legendary field hockey player, Dhyan Chand Award for Life-time Achievement Sports and Games is awarded annually by the Ministry of Youth Affairs and Sports.",
launchDate: "write",
AnualFund: "12345"},



]

export default YuthAndSportsdata;